<template>
  <div>
    <div class="wrapper flex flex-between">
      <div>
        <breadcrumb :crumbs="[$t('menu.purchases')]"></breadcrumb>
      </div>
      <div class="page-tabs">
        <router-link to="/normal/pms/purchases" class="active">{{
          $t("menu.purchases")
        }}</router-link>
        <el-divider direction="vertical"></el-divider>
        <router-link to="/normal/pms/purchases/rework"
          >{{ $t("reworkTypes.purchase") }}({{ unFinishCount }})</router-link
        >
      </div>
      <div>
        <el-button
          v-if="Permit.canActions('purchaseManage')"
          type="success"
          size="mini"
          @click="$router.push('/normal/pms/purchases/new')"
        >
          + {{ $t("text.createCustom") }}
        </el-button>
        <el-button
          v-if="Permit.canActions('purchaseManage')"
          type="primary"
          size="mini"
          @click="$router.push('/normal/pms/purchases/new-bulk')"
        >
          + {{ $t("text.createBulk") }}
        </el-button>
        <el-dropdown v-if="Permit.canActions('purchaseManage')" class="mgl10">
          <el-button type="warning" size="mini">
            + 选款下单
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="my">
              <div @click="$router.push('/normal/pms/purchases/new-quick-my')">
                我的{{ $t("menu.products") }}
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="supplier">
              <div
                @click="
                  $router.push('/normal/pms/purchases/new-quick-supplier')
                "
              >
                {{ $t("menu.supplierProducts") }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.keyword"
            :placeholder="$t('text.serialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item :prop="'categoryName'">
          <el-select
            size="small"
            v-model="searchForm.categoryName"
            :placeholder="$t('product.category')"
            clearable
            filterable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.color"
            :placeholder="$t('menu.colors')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.supplierId"
            filterable
            clearable
            :placeholder="$t('menu.suppliers')"
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="giveAt"
            :start-placeholder="$t('rules.startAt', [$t('purchase.giveAt')])"
            :end-placeholder="$t('rules.endAt', [$t('purchase.giveAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="finishAt"
            :start-placeholder="$t('rules.startAt', [$t('purchase.finishAt')])"
            :end-placeholder="$t('rules.endAt', [$t('purchase.finishAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="supplierDeliveryAt"
            :start-placeholder="
              $t('rules.startAt', [$t('dateTypes.supplierDeliveryAt')])
            "
            :end-placeholder="
              $t('rules.endAt', [$t('dateTypes.supplierDeliveryAt')])
            "
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.remark"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="Permit.canActions('purchaseRetrivePlace')"
              type="success"
              size="mini"
              @click="batchPlace"
            >
              {{ $t("action.place") }}
            </el-button>
            <el-button
              v-if="Permit.canActions('purchaseManage')"
              type="info"
              size="mini"
              @click="batchEditPrice"
            >
              {{ $t("text.edit") }}{{ $t("purchase.price") }}
            </el-button>

            <el-button
              v-if="Permit.canActionsChargeEdition('purchaseReminder')"
              type="primary"
              size="mini"
              @click="batchReminder"
            >
              {{ $t("action.reminder") }}
            </el-button>
            <el-dropdown class="mgl10" @command="selectFlag">
              <el-button type="default" size="mini">
                {{ $t("action.flag") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(flag, index) in flagsWithClear"
                  :key="index"
                  :command="flag"
                >
                  <flag :name="flag" />
                  {{ $t("flags." + flag) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.downLoadChecked") }}
                </el-dropdown-item>
                <el-dropdown-item command="search">
                  {{ $t("action.downLoadSearch") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="mgl10" @command="print">
              <el-button type="default" size="mini">
                {{ $t("action.print") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printListDiv">
                  {{ $t("action.printList") }}
                </el-dropdown-item>
                <el-dropdown-item command="printProcessListDiv">
                  {{ $t("action.printProcessList") }}
                </el-dropdown-item>
                <el-dropdown-item command="printQrCodeDiv">
                  {{ $t("action.printQrCode") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}，
              {{ pager.productNoQty }} 款 {{ pager.qtyTotal }} 件
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="checkbox" type="checkbox" width="35" />
        <vxe-table-column field="flag" :title="$t('text.flag')" width="50">
          <template v-slot="{ row }">
            <span v-if="row.flags != null && row.flags != ''">
              <flag
                v-for="flag of JSON.parse(row.flags).sort()"
                :key="flag"
                :name="flag"
              />
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <span
              class="blue"
              @click="showRow(row)"
              v-if="row.orderCancelAt == null"
            >
              {{ row.serialNo }}</span
            >
            <s
              class="grey"
              @click="showRow(row)"
              v-if="row.orderCancelAt != null"
            >
              {{ row.serialNo }}
            </s>
            <a
              v-if="row.sizeTemplate"
              class="font10 green"
              :href="row.sizeTemplate"
              target="_blank"
            >
              {{ $t("orderMes.sizeTemplate") }}
            </a>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("purchaseStates." + row.workflowState) }}
              </state-label>
            </div>
            <div v-if="row.orderCancelAt != null" class="font10 grey-shallow">
              {{ $t("purchase.orderCancelAt") }}:{{ row.orderCancelAt }}
            </div>

            <div v-if="row.settleAt != null" class="green font10">
              {{ $t("purchase.settlement") }}:{{ row.settleAt }}
            </div>
            <div v-if="row.manualSettleAt != null" class="orange font10">
              {{ $t("purchase.manualSettle") }}:{{ row.manualSettleAt }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="supplierName"
          :title="$t('menu.suppliers')"
          min-width="80"
        />
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
            >
              ({{ row.customerProductNo }})
            </small>
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row, rowIndex }">
            <raw-html-limit-number
              :content="row.remark"
              :number="12"
              type="richText"
            />
            <div class="font10">
              <i
                slot="reference"
                class="el-icon-edit"
                @click="editPurchaseRemark(row, rowIndex)"
              />
              {{ $t("purchase.purchaseRemark") }}:
              <raw-html-limit-number
                :content="row.purchaseRemark"
                :number="12"
              />
            </div>
            <div class="orange font10">
              <i
                slot="reference"
                class="el-icon-edit"
                @click="editSettlementRemark(row, rowIndex)"
              />
              {{ $t("order.settlementRemark") }}:
              <raw-html-limit-number
                :content="row.settlementRemark"
                :number="12"
              />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span :class="Number(row.quantity) > 1 ? 'red font18' : ''">
              {{ row.quantity }}{{ row.unit }}
            </span>

            <el-popover
              v-if="row.receiveQuantity != null && row.receiveQuantity != 0"
              placement="right"
              width="400"
              trigger="click"
              @show="getReceiveRecord(row)"
            >
              <vxe-table
                :data="receiveRecords"
                id="orderReceivesTable"
                ref="orderReceivesTable"
                class="recordsTable"
                size="mini"
                resizable
                round
                auto-resize
                highlight-hover-row
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="quantity"
                  :title="$t('text.quantity')"
                />
                <vxe-table-column
                  field="receiver"
                  :title="$t('receive.receiver')"
                />
                <vxe-table-column
                  field="receiveAt"
                  :title="$t('returnBack.receiveAt')"
                  width="110px"
                />
              </vxe-table>
              <div slot="reference" class="popover-reference font10">
                {{ $t("purchase.receive") }}: {{ row.receiveQuantity
                }}{{ row.unit }}
              </div>
            </el-popover>

            <div
              v-if="row.qualityQuantity != null && row.qualityQuantity != 0"
              class="font10"
            >
              {{ $t("purchase.qualityQuantity") }}:{{ row.qualityQuantity
              }}{{ row.unit }}
            </div>
            <div
              v-if="row.reworkQuantity != null && row.reworkQuantity != 0"
              class="font10 red"
            >
              {{ $t("purchase.reworkQuantity") }}:{{ row.reworkQuantity
              }}{{ row.unit }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('purchase.price')"
          min-width="80"
          v-if="Permit.canActions('globalPurchasePrice')"
        >
          <template v-slot="{ row }">
            {{ row.price | currency }}
            <div
              class="font10"
              v-if="
                row.supplierQuotedPrice != null && row.supplierQuotedPrice != ''
              "
            >
              {{ $t("product.quotation") }}:
              {{ row.supplierQuotedPrice | currency }}
            </div>
            <div
              class="font10 orange"
              v-if="
                row.changeAt != null &&
                row.purchaseChange != null &&
                row.purchaseChange.acceptAt == null
              "
            >
              <el-popover
                placement="right"
                width="300"
                trigger="click"
                class="mgr5"
              >
                <div>
                  <div class="lineH24">
                    {{ $t("allocate.applyName") }}：{{
                      row.purchaseChange.applyName
                    }}
                  </div>
                  <div class="lineH24">
                    {{ $t("allocate.applyAt") }}：{{
                      row.purchaseChange.applyAt
                    }}
                  </div>
                  <div class="lineH24">
                    {{ $t("allocate.applyRemark") }}：{{
                      row.purchaseChange.applyRemark
                    }}
                  </div>

                  <div
                    class="lineH24"
                    v-if="row.purchaseChange.acceptName != null"
                  >
                    {{ $t("allocate.acceptName") }}：{{
                      row.purchaseChange.acceptName
                    }}
                  </div>
                  <div
                    class="lineH24"
                    v-if="row.purchaseChange.acceptAt !== null"
                  >
                    {{ $t("allocate.acceptAt") }}：{{
                      row.purchaseChange.acceptAt
                    }}
                  </div>
                  <div
                    class="lineH24"
                    v-if="row.purchaseChange.rejectAt !== null"
                  >
                    {{ $t("allocate.acceptAt") }}：{{
                      row.purchaseChange.rejectAt
                    }}
                  </div>
                  <div
                    class="lineH24"
                    v-if="row.purchaseChange.rejectAt !== null"
                  >
                    {{ $t("allocate.rejectReason") }}：{{
                      row.purchaseChange.rejectReason
                    }}
                  </div>
                </div>
                <span slot="reference" class="popover-reference orange font10">
                  <span
                    v-if="
                      row.purchaseChange.rejectAt == null &&
                      row.purchaseChange.acceptAt == null
                    "
                  >
                    供应商待审:{{ row.purchaseChange.newValue | currency }}
                  </span>
                  <span v-if="row.purchaseChange.rejectAt !== null">
                    供应商拒绝:{{ row.purchaseChange.newValue | currency }}
                  </span>
                </span>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="giveAt"
          :title="$t('purchase.giveAt')"
          min-width="110"
          sortable
        />
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
            <div
              v-if="!['finished', 'untrod'].includes(row.workflowState)"
              :class="
                Util.dateDiff(row.handOverAt, new Date()) > 0 ? '' : 'red'
              "
              class="font10"
            >
              {{ $t("text.handOverAtDateMinus")
              }}{{ Util.dateDiff(row.handOverAt, new Date()) }}天
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="supplierDeliveryAt"
          :title="$t('purchase.supplierDeliveryAt')"
          min-width="110"
          sortable
        />
        <vxe-table-column
          field="finishAt"
          :title="$t('purchase.finishAt')"
          min-width="110"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.finishAt }}
            <div
              v-if="
                row.receiveHandDiffDay > 0 && row.workflowState == 'finished'
              "
              class="font10 orange"
            >
              {{ $t("purchase.receiveHandDiffDay")
              }}{{ row.receiveHandDiffDay }}天
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="printAt"
          :title="$t('order.printAt')"
          min-width="110"
        />
        <vxe-table-column
          field="ownerName"
          :title="$t('text.handle')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.handlerName }}
            <div class="font10">{{ row.handleDept }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.createName }}
            <div class="font10">{{ row.createAt }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          v-if="Permit.canActions('purchaseManage')"
          field="action"
          :title="$t('text.action')"
          width="110"
          fixed="right"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="
                ['newly', 'gived', 'accepted', 'holding'].includes(
                  row.workflowState
                ) && Permit.canActions('purchaseManage')
              "
              type="text"
              size="mini"
              class="mgr10"
              @click="edit(row, rowIndex)"
              >{{ $t("text.edit") }}
            </el-button>
            <el-dropdown>
              <a class="el-dropdown-link small-link">
                {{ $t("text.more") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div
                    class="font10"
                    @click="
                      $router.push('/normal/pms/purchases/copy-whole/' + row.id)
                    "
                  >
                    {{ $t("action.copy") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div
                    class="font10"
                    v-if="
                      !row.hurry &&
                      !['finished', 'untrod', 'canceled'].includes(
                        row.workflowState
                      ) &&
                      Permit.canActions('purchaseManage')
                    "
                    @click="updateHurry(row, rowIndex)"
                  >
                    {{ $t("order.hurry") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    [
                      'accepted',
                      'holding',
                      'holded',
                      'partially',
                      'finished',
                    ].includes(row.workflowState) &&
                    Permit.canActions('purchaseManage') &&
                    row.settleAt == null
                  "
                >
                  <div class="font10" @click="editPrice(row, rowIndex)">
                    {{ $t("text.edit") }}{{ $t("purchase.price") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    Permit.canActions('purchaseRetrivePlace') &&
                    (['gived', 'accepted', 'holding'].includes(
                      row.workflowState
                    ) ||
                      (row.workflowState === 'holded' &&
                        row.supplierTenantId == null)) &&
                    row.settleAt == null
                  "
                >
                  <div class="font10" @click="retrieve(row, rowIndex)">
                    {{ $t("action.retrive") }}
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    Permit.canActions('purchaseRetrivePlace') &&
                    (['gived', 'accepted', 'holding'].includes(
                      row.workflowState
                    ) ||
                      (row.workflowState === 'holded' &&
                        row.supplierTenantId == null)) &&
                    row.settleAt == null
                  "
                >
                  <div class="font10" @click="cancel(row, rowIndex)">
                    {{ $t("order.cancel") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    Permit.canActions('purchaseManage') &&
                    ['finished'].includes(row.workflowState) &&
                    row.untrodAt == null &&
                    row.settleAt == null
                  "
                >
                  <div class="font10" @click="returnPurchase(row, rowIndex)">
                    {{ $t("order.return") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    row.workflowState === 'newly' &&
                    row.follow === true &&
                    Permit.canActions('purchaseManage')
                  "
                >
                  <div class="font10" @click="deleteRow(row)">
                    {{ $t("text.delete") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    row.workflowState !== 'newly' &&
                    row.manualSettleAt == null &&
                    row.settleAt == null
                  "
                >
                  <div class="font10" @click="signSettle(row, rowIndex)">
                    {{ $t("action.signSettle") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    row.workflowState !== 'newly' &&
                    row.manualSettleAt !== null &&
                    row.settleAt == null
                  "
                >
                  <div class="font10" @click="cancelSignSettle(row, rowIndex)">
                    {{ $t("order.cancel") }}{{ $t("action.signSettle") }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div>
              <el-button
                v-if="
                  row.workflowState == 'newly' &&
                  Permit.canActions('purchaseRetrivePlace')
                "
                type="text"
                size="mini"
                @click="place(row, rowIndex)"
                >{{ $t("action.place") }}</el-button
              >
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <el-dialog
      :title="$t('action.reminder')"
      :close-on-click-modal="false"
      :visible.sync="reminderDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          v-model.trim="reminderObj.remark"
          size="small"
          type="textarea"
          :placeholder="$t('text.remark')"
          :autosize="{ minRows: 4 }"
          class="mb10"
        />
        <small class="orange">{{ $t("prompt.reminderExplain") }}</small>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="reminderSubmitDoing"
          size="small"
          @click="reminderSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="reminderDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印1 -->
    <div id="printProcessListDiv" style="display: none">
      <div
        v-for="cr in selectRecords"
        :key="cr.id"
        style="
          margin: 0 auto 10px;
          width: 600px;
          text-align: left;
          page-break-before: always;
        "
      >
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr>
            <td
              colspan="7"
              style="
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                height: 40px;
              "
            >
              {{ $t("menu.purchases") }}
              <small v-if="cr.hurry" style="color: red"
                >({{ $t("order.hurrySimple") }})</small
              >
              <br />
              <small>{{ cr.supplierName }}</small>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.productNo") }}：
            </td>
            <td style="border: 1px solid #dfe5ec">{{ cr.productNo }}</td>
            <td
              style="border: 1px solid #dfe5ec; width: 120px"
              rowspan="3"
              colspan="2"
            >
              <qrcode
                :value="cr.serialNo"
                :options="{ width: 100 }"
                :tag="'img'"
              />
              <!-- :value="`${cr.productNo}|${cr.color}|${cr.size}|purchase|${cr.serialNo}`" -->
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("purchase.serialNo") }}：
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ cr.serialNo }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px" rowspan="5"></td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.color") }}：
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.color }}
              <img
                v-if="cr.colorImage"
                style="max-width: 24px; max-height: 24px"
                :src="cr.colorImage"
              />
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ $t("text.handOverAt") }}：
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ cr.handOverAt }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.size") }}：
            </td>
            <td style="border: 1px solid #dfe5ec">{{ cr.size }}</td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ $t("purchase.giveAt") }}：
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ cr.giveAt }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td style="border: 1px solid #dfe5ec; width: 60px" colspan="2">
              {{ $t("product.category") }}：
            </td>
            <td style="border: 1px solid #dfe5ec; width: 60px" colspan="2">
              {{ cr.categoryName }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("text.quantity") }}：
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.quantity }}{{ cr.unit }}
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td
              style="border: 1px solid #dfe5ec; vertical-align: top"
              colspan="2"
            >
              {{ $t("product.specJson") }}：
              <br />
              <span v-if="cr.specJson != null">
                <div
                  v-for="sj of Util.tranJSONArrToArr(cr.specJson)"
                  :key="sj.name"
                >
                  <span v-if="sj.value">{{ sj.name }}:{{ sj.value }}</span>
                </div>
              </span>
              {{ $t("product.craftwork") }}:
              <raw-html :content="cr.craftwork" type="richText" />
            </td>
            <td style="border: 1px solid #dfe5ec; width: 300px" colspan="4">
              <img
                v-if="cr.firstImage"
                style="max-width: 350px"
                :src="cr.firstImage"
                width="100%"
              />
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td colspan="7">
              {{ $t("text.remark") }}：
              <raw-html :content="cr.remark" type="richText"></raw-html>
            </td>
          </tr>
          <tr
            v-if="Util.tranStringToArr(cr.images).length != 0"
            style="border: 1px solid #dfe5ec"
          >
            <td colspan="7">
              <div
                style="
                  width: 580px;
                  word-wrap: break-word;
                  word-break: break-all;
                "
              >
                <img
                  v-for="(im, imIndex) of Util.tranStringToArr(cr.images)"
                  :key="imIndex"
                  :src="im"
                  width="100"
                  style="vertical-align: top; margin-right: 10px"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 打印列表 -->
    <div id="printListDiv" style="display: none">
      <div style="width: 100%; font-size: 12px">
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            text-align: left;
            margin-bottom: 20px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <tr style="border: 1px solid black; text-align: center">
            <td
              style="border: 1px solid black; width: 80px"
              v-if="visibleColumnTitles.includes($t('product.images'))"
            >
              {{ $t("product.images") }}
            </td>
            <td
              style="border: 1px solid black; width: 120px"
              v-if="visibleColumnTitles.includes($t('text.serialNo'))"
            >
              {{ $t("text.serialNo") }}
            </td>
            <td
              style="border: 1px solid black; width: 120px"
              v-if="visibleColumnTitles.includes($t('menu.suppliers'))"
            >
              {{ $t("menu.suppliers") }}
            </td>
            <td
              style="border: 1px solid black; width: 100px"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ $t("product.productNo") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ $t("product.category") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ $t("menu.brands") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ $t("product.color") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ $t("product.size") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('text.remark'))"
            >
              {{ $t("text.remark") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('text.quantity'))"
            >
              {{ $t("text.quantity") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('purchase.price'))"
            >
              {{ $t("purchase.price") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('purchase.giveAt'))"
            >
              {{ $t("purchase.giveAt") }}
            </td>
            <td
              style="border: 1px solid black; width: 60px"
              v-if="visibleColumnTitles.includes($t('text.handOverAt'))"
            >
              {{ $t("text.handOverAt") }}
            </td>
            <td
              style="border: 1px solid black; width: 80px"
              v-if="visibleColumnTitles.includes($t('purchase.finishAt'))"
            >
              {{ $t("purchase.finishAt") }}
            </td>
          </tr>

          <tr
            style="border: 1px solid black; text-align: center"
            v-for="(item, itemIndex) in selectRecords"
            :key="itemIndex"
          >
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('product.images'))"
            >
              <img
                v-if="item.firstImage"
                style="width: 80px; height: auto"
                :src="item.firstImage"
              />
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('text.serialNo'))"
            >
              {{ item.serialNo }}
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('menu.suppliers'))"
            >
              {{ item.supplierName }}
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ item.productNo }}
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ item.categoryName || "" }}
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ item.productBrand || "" }}
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ item.color || "" }}
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ item.size || "" }}
            </td>
            <td
              style="border: 1px solid black; width: 100px"
              v-if="visibleColumnTitles.includes($t('text.remark'))"
            >
              <raw-html :content="item.remark"></raw-html>
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('text.quantity'))"
            >
              {{ item.quantity }}{{ item.unit }}
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('purchase.price'))"
            >
              {{ item.price | currency }}
            </td>
            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('purchase.giveAt'))"
            >
              {{ item.giveAt }}
            </td>

            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('text.handOverAt'))"
            >
              {{ item.handOverAt }}
            </td>

            <td
              style="border: 1px solid black"
              v-if="visibleColumnTitles.includes($t('purchase.finishAt'))"
            >
              {{ item.finishAt }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="printQrCodeDiv" style="display: none">
      <div v-for="(item, index) in selectRecords" :key="index">
        <div
          :style="{ 'page-break-before': index != 0 ? 'always' : '' }"
          align="center"
        >
          <table
            style="
              border-collapse: collapse;
              border: 1px solid #dfe5ec;
              word-wrap: break-word;
              word-break: break-all;
              text-align: center;
              font-size: 12px;
            "
          >
            <tbody>
              <tr style="border: 1px solid #dfe5ec">
                <td align="center">
                  <qrcode
                    :value="item.serialNo"
                    :options="{ width: 100 }"
                    :tag="'img'"
                  />
                  <!-- :value="`${item.productNo}|${item.color}|${item.size}|order|${item.serialNo}`" -->
                </td>
              </tr>
              <tr style="border: 1px solid #dfe5ec">
                <td>
                  {{ item.serialNo }}
                  <div>{{ item.productNo }}</div>
                  <div>{{ item.color }}-{{ item.size }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 编辑结算单备注 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editPurchaseRemarkDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="editPurchaseRemarkObj.purchaseRemark"
          type="textarea"
          :rows="5"
        ></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editPurchaseRemarkSubmitDoing"
          size="small"
          @click="editPurchaseRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPurchaseRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑结算单备注 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editSettlementRemarkDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="editSettlementRemarkObj.settlementRemark"
          type="textarea"
          :rows="5"
        ></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editSettlementRemarkSubmitDoing"
          size="small"
          @click="editSettlementRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editSettlementRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 下单 -->
    <el-dialog
      :title="$t('action.place')"
      :visible.sync="placeDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="placeObjForm" :model="placeObj" label-width="80px">
        <el-form-item
          :label="$t('menu.suppliers')"
          :prop="'supplierId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.suppliers')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="placeObj.supplierId"
            filterable
            clearable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('purchase.price')"
          :prop="'price'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('purchase.price')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="placeObj.price" />
        </el-form-item>
        <el-form-item
          :label="$t('text.handOverAt')"
          :prop="'handOverAt'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.handOverAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            size="small"
            v-model="placeObj.handOverAt"
            type="date"
            style="width: 100%"
            :picker-options="pickerTodayAfterTime"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="success"
          plain
          :loading="placeSubmitDoing"
          size="small"
          @click="placeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="placeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 退货 -->
    <el-dialog
      :title="$t('order.return')"
      :visible.sync="returnDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="returnObjForm" :model="returnObj" label-width="90px">
        <el-form-item
          prop="returnTracking"
          :label="$t('returnBack.returnTracking')"
        >
          <el-input
            size="small"
            :placeholder="$t('returnBack.returnTracking')"
            v-model.trim="returnObj.returnTracking"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('order.returnReason')" prop="reason">
          <el-input
            size="small"
            v-model.trim="returnObj.reason"
            type="textarea"
            :autosize="{ minRows: 6 }"
            :placeholder="$t('order.returnReason')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="returnDoing"
          size="small"
          @click="returnSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="returnDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.edit')"
      :visible.sync="editDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit :id="currentRowId" @updateInfo="purcaseUpdated" />
    </drawer>

    <!-- 编辑价格 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editPriceDF"
      width="30%"
    >
      <el-form ref="editPriceObjForm" :model="editPriceObj" label-width="80px">
        <el-form-item
          :prop="'price'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('purchase.price')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('purchase.price')"
        >
          <el-input
            size="small"
            v-model.trim="editPriceObj.price"
            :placeholder="$t('purchase.price')"
          ></el-input>
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="editPriceObj.remark"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editPriceDoing"
          size="small"
          @click="editPriceSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑价格 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="batchEditPriceDF"
      width="30%"
    >
      <el-form
        ref="batchEditPriceObjForm"
        :model="batchEditPriceObj"
        label-width="80px"
      >
        <el-form-item
          :prop="'price'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('purchase.price')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('purchase.price')"
        >
          <el-input
            size="small"
            v-model.trim="batchEditPriceObj.price"
            :placeholder="$t('purchase.price')"
          ></el-input>
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="batchEditPriceObj.remark"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="batchEditPriceDoing"
          size="small"
          @click="batchEditPriceSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="batchEditPriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('orderDealTypes.purchase')"
      width="70%"
      v-if="batchPlaceDF"
      :visible.sync="batchPlaceDF"
      :close-on-click-modal="false"
    >
      <batch-place
        :purchases="placeRecords"
        @close="batchPlaceDF = false"
        @updateData="batchPlaceClose"
      ></batch-place>
    </el-dialog>

    <el-dialog
      :title="$t('action.print')"
      :close-on-click-modal="false"
      :visible.sync="printDF"
      width="80%"
    >
      <vxe-table
        :data="printRecords"
        id="stockInsTable"
        row-id="id"
        ref="printRecordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <span class="blue" v-if="row.orderCancelAt == null">
              {{ row.serialNo }}</span
            >
            <s class="grey" v-if="row.orderCancelAt != null">
              {{ row.serialNo }}
            </s>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("purchaseStates." + row.workflowState) }}
              </state-label>
            </div>
            <div v-if="row.orderCancelAt != null" class="font10 grey-shallow">
              {{ $t("purchase.orderCancelAt") }}:{{ row.orderCancelAt }}
            </div>

            <div v-if="row.settleAt != null" class="green font10">
              {{ $t("purchase.settlement") }}:{{ row.settleAt }}
            </div>
            <div v-if="row.manualSettleAt != null" class="orange font10">
              {{ $t("purchase.manualSettle") }}:{{ row.manualSettleAt }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="supplierName"
          :title="$t('menu.suppliers')"
          min-width="80"
        />
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
            >
              ({{ row.customerProductNo }})
            </small>
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="12"
              type="richText"
            />
            <div>
              <attribute :content="row.specJson" :number="12" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('purchase.price')"
          min-width="80"
          v-if="Permit.canActions('globalPurchasePrice')"
        >
          <template v-slot="{ row }">
            {{ row.price | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="giveAt"
          :title="$t('purchase.giveAt')"
          min-width="110"
          sortable
        />
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
            <div
              v-if="!['finished', 'untrod'].includes(row.workflowState)"
              :class="
                Util.dateDiff(row.handOverAt, new Date()) > 0 ? '' : 'red'
              "
              class="font10"
            >
              {{ $t("text.handOverAtDateMinus")
              }}{{ Util.dateDiff(row.handOverAt, new Date()) }}天
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="finishAt"
          :title="$t('purchase.finishAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.finishAt }}
            <div
              v-if="
                row.receiveHandDiffDay > 0 && row.workflowState == 'finished'
              "
              class="font10 orange"
            >
              {{ $t("purchase.receiveHandDiffDay")
              }}{{ row.receiveHandDiffDay }}天
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.handle')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.handlerName }}
            <div class="font10">{{ row.handleDept }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column field="action" :title="$t('text.action')" width="50">
          <template v-slot="{ row, rowIndex }">
            <el-button
              type="text"
              size="mini"
              class="mgr10"
              @click="remove(row, rowIndex)"
              >{{ $t("text.remove") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          size="small"
          @click="printSubmit('printListDiv')"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="printDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Qrcode from "@chenfengyuan/vue-qrcode";
import { page, table } from "@/utils/mixins.js";
import {
  countries,
  flagsWithClear,
  flagsWithNone,
  customerTypes,
} from "@/utils/enums.js";
import DateRange from "@/components/DateRange";
import RawHtml from "@/components/RawHtml";

import Util from "@/utils/index.js";
import Show from "./show";
import Edit from "./edit";
import BatchPlace from "./batchPlace";
import Supplier from "@/api/supplier.js";
import Purchase from "@/api/purchase.js";
import Order from "@/api/order.js";
import Reminder from "@/api/reminder.js";
import Category from "@/api/category.js";
import Brand from "@/api/brand.js";
import Rework from "@/api/rework.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtml,
    DateRange,
    Qrcode,
    Show,
    Edit,
    BatchPlace,
  },
  data() {
    return {
      countries: countries,
      Util: Util,
      flagsWithClear: flagsWithClear,
      flagsWithNone: flagsWithNone,
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: Order.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: Order.passRange,
          },
          {
            label: this.$t("text.flag"),
            items: flagsWithNone.map((flag) => {
              return { flag: flag, key: flag, condition: { flag: flag } };
            }),
          },
        ],
        [
          {
            label: this.$t("text.workflowState"),
            items: Purchase.states_all.map((s) => {
              return {
                key: s,
                label: this.$t("purchaseStates." + s),
                condition: { workflowStates: [s] },
              };
            }),
          },

          {
            label: this.$t("purchase.settleInfo"),
            items: [
              {
                label: this.$t("settleInfo.yes"),
                key: "settleYes",
                condition: { settle: "yes" },
              },
              {
                label: this.$t("settleInfo.no"),
                key: "settleNo",
                condition: { settle: "no" },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
              {
                label: this.$t("text.unPrint"),
                key: "printNo",
                condition: { print: "no" },
              },
              {
                label: this.$t("purchase.purchaseing"),
                key: "purchaseing",
                condition: {
                  workflowStates: ["gived", "holding", "holded", "partially"],
                },
              },
              {
                label: this.$t("purchase.orderCancel"),
                key: "orderCancelAtYes",
                condition: {
                  orderCancelAt: "yes",
                },
              },
            ],
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        keyword: null,
        productNo: null,
        categoryName: null,
        color: null,
        size: null,
        supplierId: null,
        giveAtStartAt: null,
        giveAtEndAt: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
        finishAtStartAt: null,
        finishAtEndAt: null,
        supplierDeliveryAtStartAt: null,
        supplierDeliveryAtEndAt: null,
        handle: null,
        specJson: null,
        remark: null,
      },
      sorter: {
        sortBy: "purchases_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        giveAt: "purchases_giveAt",
        handOverAt: "purchases_handOverAt",
        supplierDeliveryAt: "purchases_supplierDeliveryAt",
        finishAt: "purchases_finishAt",
      },
      suppliers: [],
      categories: [],
      //
      currentRowId: null,
      showDF: false,
      //催单
      reminderDF: false,
      reminderType: null,
      row: null,
      reminderObj: {
        remark: null,
      },
      reminderSubmitDoing: false,
      reminderCheckedRows: [],
      //
      currentRowIdx: null,

      // 编辑注记
      editPurchaseRemarkDF: false,
      editPurchaseRemarkObj: {
        id: null,
        purchaseRemark: null,
      },
      editPurchaseRemarkSubmitDoing: false,
      // 编辑结算备注
      editSettlementRemarkDF: false,
      editSettlementRemarkObj: {
        id: null,
        settlementRemark: null,
      },
      editSettlementRemarkSubmitDoing: false,
      // 下单
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      placeDF: false,
      placeObj: {
        id: null,
        supplierId: null,
        supplierName: null,
        price: null,
        handOverAt: null,
      },
      placeSubmitDoing: false,
      // 退货
      returnDF: false,
      returnObj: {
        reason: false,
      },
      returnDoing: false,
      //
      copyDF: false,
      editDF: false,
      //
      receiveRecords: [],
      // 编辑成交单价
      editPriceDF: false,
      editPriceObj: {
        uuid: null,
        price: null,
        remark: null,
      },
      editPriceDoing: false,
      // 批量
      batchEditPriceRecords: [],
      batchEditPriceDF: false,
      batchEditPriceObj: {
        price: null,
        remark: null,
      },
      batchEditPriceDoing: false,

      unFinishCount: 0,
      //批量下单
      placeRecords: [],
      batchPlaceDF: false,
      //
      printDF: false,
      visibleColumnTitles: [],
      printRecords: [],
    };
  },

  created() {
    const self = this;
    if (JSON.stringify(self.$route.query) !== "{}") {
      self.initFilter = self.$route.query.initFilter;
    }
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    if (window.location.href.indexOf("newlys") != -1) {
      self.initFilter = "newly";
    }
    Supplier.findByTenantId(self.Permit.currentTenant().id).then(function (
      res
    ) {
      if (res.status === 200) {
        self.suppliers = res.data;
      } else {
        self.sysError();
      }
      self.getCategory();
      self.getBrand();
      self.getReworkUnFinishCount();
    });
  },
  methods: {
    getReworkUnFinishCount() {
      const self = this;
      Rework.unFinishPurchaseCount().then(function (res) {
        if (res.status == 200) {
          self.unFinishCount = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getCategory() {
      const self = this;
      Category.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.categories = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getBrand() {
      const self = this;
      Brand.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.narrows.push([
            {
              label: self.$t("product.brand"),
              items: res.data.map((brand) => {
                return {
                  label: brand.name,
                  key: brand.id,
                  condition: { productBrand: brand.name },
                };
              }),
            },
          ]);
        } else {
          self.sysError();
        }
      });
    },
    getReceiveRecord(row) {
      const self = this;
      Purchase.findReceiveRecord(row.id).then(function (res) {
        if (res.status == 200) {
          self.receiveRecords = res.data;
        } else {
          self.sysError();
        }
      });
    },

    batchPlace() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.placeRecords = self.selectRecords.filter(
        (c) => c.workflowState == "newly"
      );
      if (self.placeRecords.length === 0) {
        self.$message({
          message: self.$t("prompt.placeExplain"),
          type: "warning",
        });
        return;
      }
      self.batchPlaceDF = true;
    },
    batchPlaceClose() {
      this.batchPlaceDF = false;
      this.loadData();
    },

    // 批量编辑
    batchEditPrice() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.batchEditPriceRecords = self.selectRecords.filter(
        (c) =>
          !["canceled", "untrod"].includes(c.workflowState) &&
          c.settleAt == null
      );
      if (self.batchEditPriceRecords.length === 0) {
        self.$message({
          message: self.$t("prompt.batchEditPriceExplain"),
          type: "warning",
        });
        return;
      }
      this.batchEditPriceObj.price = null;
      this.batchEditPriceObj.remark = null;
      this.batchEditPriceDF = true;
    },
    batchEditPriceSubmit() {
      const self = this;
      self.$refs.batchEditPriceObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.batchEditPriceObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("purchase.price")]),
              type: "warning",
            });
            return;
          }
          const datas = self.batchEditPriceRecords.map((c) => {
            return {
              uuid: c.uuid,
              price: self.batchEditPriceObj.price,
              remark: self.batchEditPriceObj.remark,
            };
          });
          self.batchEditPriceDoing = true;
          Purchase.batchUpdatePrice(datas).then(function (res) {
            self.batchEditPriceDoing = false;
            if (res.status == 200) {
              self.sysResults(res.data);
              self.batchEditPriceDF = false;
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //编辑成交单价
    editPrice(row, rowIndex) {
      this.row = row;
      this.currentRowIdx = rowIndex;
      this.editPriceObj.uuid = row.uuid;
      this.editPriceObj.price = row.price;
      this.editPriceObj.remark = null;
      this.editPriceDF = true;
    },
    editPriceSubmit() {
      const self = this;
      self.$refs.editPriceObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editPriceObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("purchase.price")]),
              type: "warning",
            });
            return;
          }
          self.editPriceDoing = true;
          Purchase.updatePrice(self.editPriceObj).then(function (res) {
            self.editPriceDoing = false;
            if (res.status == 200) {
              self.sysResult(res.data);
              self.editPriceDF = false;
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑
    edit(row, rowIndex) {
      this.currentRowId = row.id;
      this.currentRowIdx = rowIndex;
      this.editDF = true;
    },
    purcaseUpdated(purchase) {
      for (const key in this.records[this.currentRowIdx]) {
        this.records[this.currentRowIdx][key] = purchase[key];
      }
      this.editDF = false;
    },
    // 退货
    returnPurchase(row, rowIndex) {
      this.row = row;
      this.currentRowIdx = rowIndex;
      this.returnObj.reason = null;
      this.returnDoing = false;
      this.returnDF = true;
    },
    returnSubmit() {
      const self = this;
      self.returnDoing = true;
      Purchase.returnBack(this.row.id, this.returnObj).then(function (res) {
        self.returnDoing = false;
        self.returnDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.returnSuccess"),
            type: "success",
          });
          self.records[self.currentRowIdx].workflowState = "untrod";
          self.$eventHub.$emit("purchaseReturnBack");
        } else {
          self.sysError();
        }
      });
    },
    // 取消
    cancel(row, rowIndex) {
      const self = this;
      self.retriveDoing = true;
      Purchase.cancel(row.id).then(function (res) {
        self.retriveDoing = false;
        if (res.status === 200) {
          self.sysResult(res.data);
          if (res.data.type == "success") {
            self.records[rowIndex].workflowState = "canceled";
          }
        } else {
          self.sysError();
        }
      });
    },

    // 撤单
    retrieve(row, rowIndex) {
      const self = this;
      self.retriveDoing = true;
      Purchase.retrieve(row.id).then(function (res) {
        self.retriveDoing = false;
        if (res.status === 200) {
          self.sysResult(res.data);
          self.loadData();
          self.$eventHub.$emit("purchaseRetrieve");
        } else {
          self.sysError();
        }
      });
    },

    // 标记结算
    cancelSignSettle(row, rowIndex) {
      const self = this;
      Purchase.cancelSettle(row.id).then(function (res) {
        if (res.status == 200) {
          self.records[rowIndex].manualSettleAt = null;
          self.$message({
            message: self.$t("prompt.signSettleSucces"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    // 标记结算
    signSettle(row, rowIndex) {
      const self = this;
      Purchase.settle(row.id).then(function (res) {
        if (res.status == 200) {
          self.records[rowIndex].manualSettleAt = Util.formatDate(new Date());
          self.$message({
            message: self.$t("prompt.signSettleSucces"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Purchase.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("purchaseDelete");
          } else {
            self.sysError();
          }
        });
      }
    },
    //
    updateHurry(row, rowIndex) {
      const self = this;
      Purchase.hurry(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.hurrySuccess"),
            type: "success",
          });
          self.records[rowIndex].hurry = true;
        } else {
          self.sysError();
        }
      });
    },
    //下单
    place(row, rowIndex) {
      const self = this;
      self.currentRowIdx = rowIndex;
      self.placeObj.id = row.id;
      self.placeObj.supplierId = null;
      self.placeObj.price = row.price;
      self.placeObj.handOverAt = row.handOverAt;
      self.placeSubmitDoing = false;
      self.placeDF = true;
    },
    placeSubmit() {
      const self = this;
      this.$refs.placeObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.placeObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("purchase.price")]),
              type: "warning",
            });
            return;
          }
          self.placeObj.supplierName = self.suppliers.find(
            (s) => s.id === self.placeObj.supplierId
          ).name;
          self.placeObj.handOverAt = Util.formatDate(self.placeObj.handOverAt);
          self.placeSubmitDoing = true;
          Purchase.place(self.placeObj).then(function (res) {
            self.placeSubmitDoing = false;
            self.placeDF = false;
            self.$message({
              message: self.$t("prompt.placeSuccess"),
              type: "success",
            });
            self.records[self.currentRowIdx].supplierId =
              self.placeObj.supplierId;
            self.records[self.currentRowIdx].supplierName =
              self.placeObj.supplierName;
            self.records[self.currentRowIdx].price = self.placeObj.price;
            self.records[self.currentRowIdx].handOverAt =
              self.placeObj.handOverAt;
            self.records[self.currentRowIdx].workflowState = "gived";
            self.$eventHub.$emit("purchasePlace");
          });
        } else {
          return false;
        }
      });
    },

    // 编辑账单备注
    editPurchaseRemark(row, index) {
      const self = this;
      self.currentRowIdx = index;
      self.editPurchaseRemarkObj.id = row.id;
      self.editPurchaseRemarkObj.purchaseRemark = row.purchaseRemark;
      self.editPurchaseRemarkSubmitDoing = false;
      self.editPurchaseRemarkDF = true;
    },
    editPurchaseRemarkSubmit() {
      const self = this;
      self.editPurchaseRemarkSubmitDoing = true;
      Purchase.updatePurchaseRemark(self.editPurchaseRemarkObj).then(function (
        res
      ) {
        self.editPurchaseRemarkSubmitDoing = false;
        self.editPurchaseRemarkDF = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
          self.records[self.currentRowIdx].purchaseRemark =
            self.editPurchaseRemarkObj.purchaseRemark;
        } else {
          self.sysError();
        }
      });
    },
    // 编辑账单备注
    editSettlementRemark(row, index) {
      const self = this;
      self.currentRowIdx = index;
      self.editSettlementRemarkObj.id = row.id;
      self.editSettlementRemarkObj.settlementRemark = row.settlementRemark;
      self.editSettlementRemarkSubmitDoing = false;
      self.editSettlementRemarkDF = true;
    },
    editSettlementRemarkSubmit() {
      const self = this;
      self.editSettlementRemarkSubmitDoing = true;
      Purchase.updateSettleRemark(self.editSettlementRemarkObj).then(function (
        res
      ) {
        self.editSettlementRemarkSubmitDoing = false;
        self.editSettlementRemarkDF = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
          self.records[self.currentRowIdx].settlementRemark =
            self.editSettlementRemarkObj.settlementRemark;
        } else {
          self.sysError();
        }
      });
    },
    //
    print(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.printRecords = self.selectRecords;
      if (type == "printListDiv") {
        let visibleColumn = self.$refs.recordsTable.getColumns();
        self.visibleColumnTitles = visibleColumn.map((c) => c.title);
        self.printDF = true;
        return;
      }
      self.printSubmit(type);
    },
    remove(row, rowIndex) {
      this.printRecords.splice(rowIndex, 1);
    },
    printSubmit(type) {
      const self = this;
      let ids = [];
      if (type == "printListDiv") {
        ids = self.printRecords.map((c) => c.id);
      } else {
        ids = self.selectRecords.map((c) => c.id);
      }
      Purchase.print(ids).then(function (res) {
        if (res.status === 200) {
          self.printFunction(type);
          self.loadData();
        } else {
          self.sysError();
        }
        self.printDF = false;
      });
    },
    //
    batchReminder() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.reminderCheckedRows = self.selectRecords.filter(
        (c) =>
          c.supplierTenantId != null &&
          ["holding", "holded", "partially"].includes(c.workflowState)
      );
      if (self.reminderCheckedRows.length === 0) {
        self.$message({
          message: self.$t("prompt.reminderExplain"),
          type: "warning",
        });
        return;
      }
      self.reminderObj.remark = null;
      self.reminderSubmitDoing = false;
      self.reminderDF = true;
    },
    reminderSubmit() {
      const self = this;
      self.reminderSubmitDoing = true;
      const data = self.reminderCheckedRows.map((c) => {
        return { entityUuid: c.uuid, remark: self.reminderObj.remark };
      });
      Reminder.insertBatch(data).then(function (res) {
        self.reminderSubmitDoing = false;
        self.reminderDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.reminderSuccess"),
            type: "success",
          });
          self.$eventHub.$emit("reminderInsertBatch");
        } else {
          self.sysError();
        }
      });
    },
    // 下载
    download(type) {
      const self = this;
      if (type == "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectRecords.map((c) => c.id),
        };
        self.downloadData(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Purchase.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 标旗帜
    selectFlag(f) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const data = [];
      for (const c of self.selectRecords) {
        const obj = { uuid: c.uuid, flags: null };
        if (f === "clear") {
          obj.flags = JSON.stringify([]);
        } else {
          const arr = c.flags != null ? JSON.parse(c.flags) : [];
          const newArr = [...new Set(arr.concat([f]))];
          obj.flags = JSON.stringify(newArr);
        }
        data.push(obj);
      }
      Purchase.updateFlags(data).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.signSuccess"),
            type: "success",
          });
          for (const r of self.records) {
            if (data.find((d) => d.uuid == r.uuid) != null) {
              r.flags = data.find((d) => d.uuid == r.uuid).flags;
            }
          }
          self.clearSelected();
        } else {
          self.sysError();
        }
      });
    },
    //
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    //
    dataProvider(params) {
      return Purchase.search(params);
    },
  },
};
</script>
